import { legacyLocalLabel } from '../../../../utilities/legacyDatePresentation';
import React from "react";
import SummaryCard from "./SummaryCard";
import { Activity, DollarSign, Gauge, Calendar } from "lucide-react";
import { SubscriptionDto } from "../../../../interfaces";
import { centToUSD } from "../../../../utilities/common/commonFuntion";


interface UsageSummaryProps {
    subscription: SubscriptionDto
}


const UsageSummary: React.FC<UsageSummaryProps> = ({
    subscription
}) => {

    const constPerUnit = subscription.plan?.seatPriceCents ? centToUSD(subscription.plan?.seatPriceCents) : "Na";
    const baseAmount = subscription.plan?.basePriceCents ? centToUSD(subscription.plan?.basePriceCents) : "Na";
    const nextBillingDate = subscription.nextBillingDate ? legacyLocalLabel(subscription.nextBillingDate, "MMM dd, yyyy") : "Na";
    return (
        <div className="usage-wrapper">
            <h4 className="section-title">Usage Summary</h4>

            <div className="summary-grid">
                <SummaryCard
                    icon={<Activity size={20} />}
                    title="Total Usage This Cycle"
                    value={subscription.seatCountActive.toString()}
                    subtitle="User"
                />


                <SummaryCard
                    icon={<DollarSign size={20} />}
                    title="Cost Per Unit"
                    value={constPerUnit || ""}
                    subtitle="per User"
                />

                <SummaryCard
                    icon={<Gauge size={20} />}
                    title="Base Amout"
                    value={baseAmount || ""}
                />

                <SummaryCard
                    icon={<Calendar size={20} />}
                    title="Next Billing Date"
                    value={nextBillingDate}
                />
            </div>

            {/* <div className="usage-progress">
        <div className="progress-text">
          <span>Usage limit (soft cap: 5,000 calls)</span>
          <span>24.8%</span>
        </div>

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: "24.8%" }} />
        </div>
      </div> */}

            {/* <div className="auto-charge">
                <div>
                    <p className="auto-title">Auto-charge at end of cycle</p>
                    <p className="auto-desc">
                        Automatically charge your saved payment method
                    </p>
                </div>

                <label className="switch" title="Auto charge is managed by billing settings">
                    <input type="checkbox" checked disabled />
                    <span className="slider"></span>
                </label>
            </div> */}
        </div>
    );
};

export default UsageSummary;